/**
 * Sanitizes text input by removing potentially harmful characters
 * and limiting length
 */
export const sanitizeText = (text: string, maxLength: number = 100): string => {
  if (!text) return '';
  
  // Remove any HTML tags
  let sanitized = text.replace(/<[^>]*>/g, '');
  
  // Remove special characters but keep basic punctuation
  sanitized = sanitized.replace(/[^\w\s.,!?-]/g, '');
  
  // Trim whitespace and limit length
  sanitized = sanitized.trim().slice(0, maxLength);
  
  return sanitized;
};

/**
 * Sanitizes an array of tags
 */
export const sanitizeTags = (tags: string[]): string[] => {
  if (!Array.isArray(tags)) return [];
  
  return tags
    .map(tag => {
      // Remove special characters and spaces
      let sanitized = tag.toLowerCase().replace(/[^\w\s-]/g, '');
      // Replace spaces with hyphens
      sanitized = sanitized.replace(/\s+/g, '-');
      // Trim and limit length
      return sanitized.trim().slice(0, 30);
    })
    // Remove empty tags and duplicates
    .filter((tag, index, self) => 
      tag.length > 0 && 
      tag.length <= 30 && 
      self.indexOf(tag) === index
    )
    // Limit number of tags
    .slice(0, 10);
};
